/** Analog mission clocks: hour, minute and second hands, drawn from an elapsed time in seconds. */
export function drawClock(canvas: HTMLCanvasElement, seconds: number, color: string) {
  const g = canvas.getContext('2d');
  if (!g) return;
  const S = canvas.width, cx = S / 2, cy = S / 2, r = S * 0.42;
  g.clearRect(0, 0, S, S);
  g.beginPath(); g.arc(cx, cy, r, 0, Math.PI * 2);
  g.fillStyle = 'rgba(8,11,26,0.82)'; g.fill();
  g.strokeStyle = 'rgba(236,232,223,0.35)'; g.lineWidth = 2; g.stroke();
  for (let k = 0; k < 12; k++) {
    const a = k / 12 * Math.PI * 2;
    g.beginPath(); g.moveTo(cx + Math.sin(a) * (r - 7), cy - Math.cos(a) * (r - 7)); g.lineTo(cx + Math.sin(a) * r, cy - Math.cos(a) * r);
    g.strokeStyle = 'rgba(169,171,189,0.8)'; g.lineWidth = k % 3 === 0 ? 3 : 1.5; g.stroke();
  }
  const sec = (seconds % 60) / 60 * Math.PI * 2;
  const min = (seconds % 3600) / 3600 * Math.PI * 2;
  const hr = (seconds % 43200) / 43200 * Math.PI * 2;
  hand(g, cx, cy, hr, r - 30, 5, color);
  hand(g, cx, cy, min, r - 18, 3.5, color);
  hand(g, cx, cy, sec, r - 10, 1.5, color);
  g.beginPath(); g.arc(cx, cy, 3, 0, Math.PI * 2); g.fillStyle = color; g.fill();
}

function hand(g: CanvasRenderingContext2D, cx: number, cy: number, a: number, len: number, w: number, color: string) {
  g.beginPath(); g.moveTo(cx, cy); g.lineTo(cx + Math.sin(a) * len, cy - Math.cos(a) * len);
  g.strokeStyle = color; g.lineWidth = w; g.lineCap = 'round'; g.stroke();
}
